import 'rc-progress/assets/index.css';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Line } from 'rc-progress';

import './lineProgressBar.scss'

class LineProgressBar extends Component {
  constructor(props) {
    super(props);
    this.progrssInterval = setInterval(() => {
      this.changePercent();
    }, 1000);
  }

  state = {
    percent: 0,
    progressDone: false
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.progressDone !== prevState.progressDone) {
      return {
        progressDone: nextProps.progressDone
      };
    }
    return null;
  }

  changePercent = () => {
    if (this.state.progressDone) {
      this.setState({ percent: 100 });
    }
    if (this.state.percent < 100) {
      const newPercent = this.state.percent + 1;
      this.setState({ percent: newPercent });
    } else {
      clearInterval(this.progrssInterval);
    }
  };

  render() {
    const { strokeColor, strokeWidth,trailColor,trailWidth, barWidth } = this.props;
    const containerStyle = {
      width: barWidth,
      textAlign:'center',
      margin: '15px'
    };
    return (
      <div style={containerStyle}>
          <span style={{fontSize:'22px'}}>{this.props.title} <span style={{fontSize:'22px',color:'#15c4ab'}}>{`${this.state.percent} %`}</span></span>
        <Line
          percent={this.state.percent}
          strokeWidth={strokeWidth}
          strokeColor={strokeColor}
          trailWidth={trailWidth}
          trailColor={trailColor}
        />
      </div>
    );
  }
}

LineProgressBar.propTypes = {
  /** The width of the progress bar */
  barWidth: PropTypes.string,
  /** The width of the stroke bar */
  strokeWidth: PropTypes.string
  /** The color of the stroke bar */
};

LineProgressBar.defaultProps = {
  barWidth: '100%',
  strokeWidth: '0.75',
  strokeColor: '#15c4ab',
  trailColor: '#3f3f3f',
  trailWidth: '0.75'
};

export default LineProgressBar;
